import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  media: ".product__media > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(node, [selectors.media]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
